import HamburgerMenu from './HamburgerMenu'
import './mobileNav.scss'
import React from 'react'

const MobileNav = ({  pageContext, setIsAccordionOpen, menu, secondaryMenu, logoSrc, homePath }) => {
  return (
    <div className="mobile">
      <div className="mobile-navbar">
        <HamburgerMenu
          menu={menu}
          secondaryMenu={secondaryMenu}
          setIsAccordionOpen={setIsAccordionOpen}
          logoSrc={logoSrc}
          homePath={homePath}
          pageContext={pageContext}
        />
      </div>
    </div>
  )
}

export default MobileNav
